import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full border-l-[10px] border-primary-400 mt-8 mb-8 text-2xl text-left font-extrabold pt-2 pb-2 pl-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " Mis comunidades ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mx-7" }, " Panel de Administración ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBox = _resolveComponent("SearchBox")!
  const _component_AdminBar = _resolveComponent("AdminBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_SearchBox)
    ]),
    _createVNode(_component_AdminBar, {
      communityId: parseInt(_ctx.id)
    }, null, 8, ["communityId"])
  ], 64))
}